import { useMediaContext } from './useMediaContext';
import { UrlsType } from '../types/event';
import { MediaObject } from '../../../types/media';

type MediaResponse = {
  photos: MediaObject[];
  mediaUrl?: string;
  urls?: UrlsType
};
export const useMedia = (): MediaResponse => {
  const { media, urls } = useMediaContext();
  return {
    photos: Object.values({ ...media }),
    mediaUrl: urls?.media,
    urls
  };
};
